import React from "react";
import { AgGridReact } from "ag-grid-react";
import { useMemo, useState, useCallback, useRef, useEffect } from "react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "ag-grid-community/dist/styles/ag-theme-balham-dark.css";
import * as Icon from "react-bootstrap-icons";

import { Button, OverlayTrigger,Tooltip, Row, Col } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import _ from 'lodash';
import CheckboxTree from "react-checkbox-tree-enhanced";
import { getValuesAsList, OptionRenderer } from "../../utils"
import { makeCygnusApiCall } from "../../api/api";
import { CustomButton } from "../../reusable-components/CustomButtonComponent/button";

/**
 * A grid cell renderer button.
 * @param {*} props: props include the selected row data for editing.
 * @returns A button for editing the row in grid.
 */
const BtnCellRenderer = (props) => {
    const editClick = () => {
        props.setModal(true);
        props.selectedRow(props.data);
    }

    return (
        <div className="flex-row-space-center" style={{ width: 100 }}>
            <>
                <OverlayTrigger
                    placement="bottom"
                    delay={{ show: 250, hide: 400 }}
                    overlay={
                        <Tooltip id="button-tooltip">
                            Edit User Role
                        </Tooltip>
                    }
                    error={true}
                >
                    <Button className="grid-button" style={{
                                padding: "0px", margin: "0px",
                                width: "100%", height: "100%"
                            }}
                            onClick={() => editClick()}>
                            <Icon.PencilSquare />
                    </Button>                 
                </OverlayTrigger>
            </>    
        </div>
        

    );
}

/**
 * A grid cell renderer button. This functionality is not currently used and might be used in future.
 * @param {*} props: props include the selected user data for activating / deactivating.
 * @returns Toggle button to activate or deactivate user. 
 */
const DeactivateUserRenderer = (props) => {
    let token = localStorage.getItem("token");
    const [activeToggle, setActiveToggle] = useState(props.data.Active);
    const handleDeactivate = async (props) => {
        setActiveToggle(!activeToggle)
        const payload = {
            "FirmId": props.data["Firm Id"],
            "Active": !activeToggle ? "Y" : "N"
        }
        console.log("PAYLOAD: ", payload)
        const _ = await makeCygnusApiCall({
            type: "POST",
            payload: payload,
            url: `/subscriptions/packages/firms/active_status/`,
            show_message: false,
            customized_success_message: "Successful updated user status.",
            customized_failure_message: "Unable to deactivate user, please try again. If the problem persists, please contact support and attach a screenshot.",
            customized_error_message: "Error occured while deactivating user, please contact support and attach a screenshot.",
            isblob: false
        })
    }
    const Switch = ({ isToggled, onClick }) => {
        return (
            <label className="switch">
                <input type="checkbox" checked={isToggled} onChange={onClick} />
                <span className="slider round"></span>
            </label>
        );
    };

    return (
        <>
            <Switch
                isToggled={activeToggle}
                onClick={() => handleDeactivate(props)}
            ></Switch>
        </>
    );
}

function MyVerticallyCenteredModalEditRoles(props) {
    // console.log("MODAL EDIR PROPS: ", props)
    let token = localStorage.getItem("token");
    const [selectedRole, setSelectedRole] = useState(OptionRenderer([props.selectedrowdata.Role]));
    const [apiInProgress, setApiInProgress] = useState(false);
    const [userActiveStatus, setUserActiveStatus] = useState(props.selectedrowdata.Active);
    const editUser = async (props) => {
        setApiInProgress(true)
        // console.log("EDIT FIRM PLANS: ", props)
        const payload = {
            "data": [
                {
                    "UserName": props.selectedrowdata["User Name"],
                    "Role": selectedRole.value ?? selectedRole[0].value
                }
            ]
        };
        const _ = await makeCygnusApiCall({
            type: "POST",
            payload: payload,
            url: `/subscriptions/roles/users/`,
            show_message: true,
            customized_success_message: "Successful saved user details.",
            customized_failure_message: "Unable to save user details, please try again. If the problem persists, please contact support and attach a screenshot.",
            customized_error_message: "Error occured while saving user details, please contact support and attach a screenshot.",
            isblob: false
        })
        const body = {                         
            username: props.selectedrowdata["User Name"],
            active: userActiveStatus                         
        };
        const __ = await makeCygnusApiCall({
            type: "POST",
            payload: body,
            url: `/user/disable/`,
            show_message: true,
            customized_success_message: "Successful saved user status.",
            customized_failure_message: "Unable to save user status, please try again. If the problem persists, please contact support and attach a screenshot.",
            customized_error_message: "Error occured while saving user status, please contact support and attach a screenshot.",
            isblob: false
        })        
        setApiInProgress(false)
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            backdrop="static"
            centered
            className="admin-modal"
            scrollable="false"
        >
            <Modal.Header closeButton>
                <h5>Manage User</h5>
            </Modal.Header>
            <Modal.Body className="show-grid">
                <span className="select-label">Selected user: <h5 style={{ fontSize: "var(--h7" }}>{props.selectedrowdata["User Name"]}</h5></span>
                <hr />
                <span className="select-label">Select your role: <span style={{ color: 'red', fontSize: '0.8em', verticalAlign: 'super' }}>*</span> </span>
                <Select
                    options={OptionRenderer(getValuesAsList(props.allroles))}
                    value={selectedRole}
                    aria-label="Default"
                    closeMenuOnSelect={true}
                    autosize={true}
                    placeholder="Select your plan"
                    menuPosition="fixed"
                    defaultValue={selectedRole}
                    onChange={setSelectedRole}
                    // isLoading={isSelectOptionsLoading}
                    className='custom-select '
                    classNamePrefix="react-select"
                    isClearable
                />
                <Row style={{ width: "100%", marginBottom: 10, marginTop: 10 }} className="flex-row-center-start">
                    <Col md={2} style={{ marginLeft: "10px", paddingLeft: 0 }}>
                        <h6 style={{ marginBottom: 0 }}>Status: </h6>
                    </Col>
                    <Col md={3} style={{ marginRight: "0px" }}>
                        <input class="form-check-input" type="radio" name="inlineRadioOptions" style={{ marginLeft: "0px", marginRight: "5px" }}
                            id="setUserActive" value="Active" defaultChecked={userActiveStatus === 'Y'}  
                            onClick={() => setUserActiveStatus('Y')}/>
                        <label class="form-check-label" for="send_for_approval_sequential">Active</label>
                    </Col>
                    <Col md={3} style={{ marginRight: "0px" }}>
                        <input class="form-check-input" type="radio" name="inlineRadioOptions" style={{ marginRight: "5px" }}
                            id="setUserInactive" value="Parallel" defaultChecked={userActiveStatus === 'N'} 
                            onClick={() => setUserActiveStatus('N')} />
                        <label class="form-check-label" for="send_for_approval_parallel">InActive</label>
                    </Col>
                    <Col md={3} style={{ marginRight: "0px" }}>
                        <input class="form-check-input" type="radio" name="inlineRadioOptions" style={{ marginRight: "5px" }}
                            id="setUserUnlock" value="Parallel" defaultChecked={userActiveStatus === 'L'} 
                            onClick={() => setUserActiveStatus('L')} />
                        <label class="form-check-label" for="send_for_approval_parallel">Locked</label>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer className="action-footer">
                <CustomButton
                    progress={apiInProgress}
                    onclick={() => editUser(props)}
                    content={apiInProgress ? "Updating" : "Update"}
                    disable={apiInProgress || !selectedRole}
                />
            </Modal.Footer>
        </Modal>
    );
}

function MyVerticallyCenteredModalEditFeatures(props) {
    let token = localStorage.getItem("token");
    const preSelectedValues = props.selectedrowdata["Features"];
    const [checked, setChecked] = useState(preSelectedValues);
    const [expanded, setExpanded] = useState([]);
    const [apiInProgress, setApiInProgress] = useState(false);
    const treeNodes = props.treenodes;
    const onCheck = (value) => { setChecked(value) };
    const onExpand = (value) => { setExpanded(value) };
    const editRoleFeatures = async (props) => {
        setApiInProgress(true)
        const selectedFeatures = []
        const allFeatures = props.allfeatures
        for (let option in checked) {
            for (const feature in allFeatures) {
                if (allFeatures[feature].Name == checked[option]) {
                    selectedFeatures.push(allFeatures[feature].FeatureId)
                }
            }
        }
        const payload = {
            "Role": props.selectedrowdata["Role"],
            "Features": selectedFeatures
        }
        const _ = await makeCygnusApiCall({
            type: "POST",
            payload: payload,
            url: `/subscriptions/roles/update/`,
            show_message: true,
            customized_success_message: "Successful updated role features.",
            customized_failure_message: "Unable to update role features, please try again. If the problem persists, please contact support and attach a screenshot.",
            customized_error_message: "Error occured while updating role features, please contact support and attach a screenshot.",
            isblob: false
        })
        setApiInProgress(false)
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            backdrop="static"
            centered
            className="admin-modal"
            scrollable="false"
        >
            <Modal.Header closeButton>
                <h5>Manage features for {props.selectedrowdata["Role"]}</h5>
            </Modal.Header>
            <Modal.Body className="show-grid  ">
                <span className="select-label">Selected role: <h5 style={{ fontSize: "var(--h7" }}>{props.selectedrowdata["Role"]}</h5></span>
                <hr />
                <br />
                <span className="select-label">Select features to enable or disable: </span>
                <CheckboxTree
                    checked={checked}
                    expanded={expanded}
                    nodes={treeNodes}
                    onCheck={onCheck}
                    onExpand={onExpand}
                />
            </Modal.Body>
            <Modal.Footer className="action-footer">
                <CustomButton
                    progress={apiInProgress}
                    onclick={() => editRoleFeatures(props)}
                    content={apiInProgress ? "Updating" : "Update"}
                    disable={apiInProgress}
                />
            </Modal.Footer>
        </Modal>
    );
}

export const FirmAdminRoleGrid = (props) => {
    // console.log("FIRM ADMIN ROLE GRID PROPS: ", props)
    const gridRef = useRef();
    const gridStyle = useMemo(() => ({ height: "78vh", width: "100%" }), []);
    const onFirstDataRendered = useCallback(() => { gridRef.current.api.sizeColumnsToFit() }, []);
    const defaultColDef = useMemo(() => ({
        sortable: true,
        filter: true,
        resizable: true,
        animateRows: true,
    }), []);
    const [modalShow, setModalShow] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState({});
    const onSelectionChanged = () => { const selectedData = gridRef.current.api.getSelectedRows() };
    const [columnDefs, setColumnDefs] = useState([
        
        { field: "FirstName", headerName: "First Name", enablePivot: true, resizable: true, suppressSizeToFit: true, flex: 1 },
        { field: "LastName", headerName: "Last Name", enablePivot: true, resizable: true, suppressSizeToFit: true, flex: 1 },
        { field: "User Name", enablePivot: true, resizable: true, suppressSizeToFit: true, flex: 1 },
        { field: "Role", enablePivot: true, suppressSizeToFit: true, flex: 1 },
        { field: "Active", enablePivot: true, headerName: "Status", flex: 1,
            valueFormatter: (params) => {
                switch (params.value) {
                    case "Y":
                        return "Active";
                    case "N":
                        return "Inactive";
                    case "L":
                        return "Locked";
                    default:
                        return params.value;
                }
            }
        },
        {
            field: "Actions", enablePivot: true,
            cellStyle: { 'border-right-color': '#ccc' },
            maxWidth: 100,
            cellRenderer: BtnCellRenderer,
            cellRendererParams: {
                setModal: setModalShow,
                selectedRow: setSelectedRowData
            }
        }
    ]);
    const allRoles = props.allRolesData;
    return (
        <>
            {modalShow
                ?
                <MyVerticallyCenteredModalEditRoles
                    show={modalShow}
                    allroles={allRoles}
                    selectedrowdata={selectedRowData}
                    onHide={() => setModalShow(false)}
                />
                :
                <></>
            }
            <div className="ag-theme-balham" style={gridStyle}>
                <AgGridReact
                    ref={gridRef}
                    rowData={props.rowData}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    onGridReady={props.onGridReady}
                    alwaysShowHorizontalScroll={false}
                    alwaysShowVerticalScroll={false}
                    sideBar={"filters"}
                    onFirstDataRendered={onFirstDataRendered}
                    suppressRowClickSelection={true}
                    rowSelection={true}
                    onSelectionChanged={onSelectionChanged}
                />
            </div>
        </>
    );
};

export const FirmAdminFeatureGrid = (props) => {
    // console.log("FIRM ADMIN FEATURE GRID PROPS: ", props)
    const gridRef = useRef();
    const gridStyle = useMemo(() => ({ height: "78vh", width: "100%" }), []);
    const onFirstDataRendered = useCallback(() => { gridRef.current.api.sizeColumnsToFit() }, []);
    const defaultColDef = useMemo(() => ({
        sortable: true,
        filter: true,
        resizable: true,
        animateRows: true,
    }), []);
    const [modalShow, setModalShow] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState({});
    const onSelectionChanged = () => { const selectedData = gridRef.current.api.getSelectedRows() };
    const [columnDefs, setColumnDefs] = useState([
        { field: "Role", enablePivot: true, resizable: true, suppressSizeToFit: true },
        { field: "Features", enablePivot: true},
        {
            field: "Actions", enablePivot: true,
            cellStyle: { 'border-right-color': '#ccc' },
            maxWidth: 100,
            cellRenderer: BtnCellRenderer,
            cellRendererParams: {
                setModal: setModalShow,
                selectedRow: setSelectedRowData
            }
        }
    ]);
    const allFeatures = props.allFeaturesData;

    return (
        <>
            {modalShow
                ?
                <MyVerticallyCenteredModalEditFeatures
                    show={modalShow}
                    allfeatures={allFeatures}
                    selectedrowdata={selectedRowData}
                    treenodes={props.checkTreeNodes}
                    onHide={() => setModalShow(false)}
                />
                :
                <></>
            }
            <div className="ag-theme-balham" style={gridStyle}>
                <AgGridReact
                    ref={gridRef}
                    rowData={props.rowData}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    onGridReady={props.onGridReady}
                    alwaysShowHorizontalScroll={false}
                    alwaysShowVerticalScroll={false}
                    sideBar={"filters"}
                    onFirstDataRendered={onFirstDataRendered}
                    suppressRowClickSelection={true}
                    rowSelection={true}
                    onSelectionChanged={onSelectionChanged}
                />
            </div>
        </>
    );
};
